import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Glitch-like geometric shapes */}
        <div className="absolute top-[20%] left-[10%] w-32 h-32 border border-[var(--alert-coral)] opacity-10 rotate-12" />
        <div className="absolute top-[25%] left-[12%] w-32 h-32 border border-[var(--weave-400)] opacity-10 rotate-[15deg]" />
        <div className="absolute bottom-[20%] right-[15%] w-24 h-24 border border-[var(--energy-cyan)] opacity-10 -rotate-12" />
        <div className="absolute bottom-[25%] right-[18%] w-24 h-24 border border-[var(--weave-300)] opacity-10 -rotate-[15deg]" />
        
        {/* Central pulse */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(255,64,64,0.1)_0%,transparent_70%)] animate-[breathe_4s_ease-in-out_infinite]" />
      </div>

      {/* Content */}
      <div className="glass-panel p-12 max-w-lg text-center relative">
        {/* Corner accents */}
        <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-[var(--alert-coral)] opacity-60" />
        <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-[var(--alert-coral)] opacity-60" />
        <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-[var(--weave-400)] opacity-40" />
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-[var(--weave-400)] opacity-40" />

        {/* 404 Number */}
        <div className="relative mb-8">
          {/* Background glow */}
          <div className="absolute inset-0 flex items-center justify-center blur-2xl opacity-30">
            <span className="text-8xl font-bold text-[var(--alert-coral)]">404</span>
          </div>
          
          {/* Main text */}
          <h1 className="relative text-8xl font-bold tracking-wider">
            <span className="bg-gradient-to-r from-[var(--alert-coral)] via-[var(--weave-300)] to-[var(--energy-cyan)] bg-clip-text text-transparent">
              404
            </span>
          </h1>
        </div>

        {/* Error Icon */}
        <div className="relative w-16 h-16 mx-auto mb-6">
          <div className="absolute inset-0 border-2 border-[var(--alert-coral)] rotate-45 animate-[pulse-glow_2s_ease-in-out_infinite]" style={{ boxShadow: '0 0 20px rgba(255, 64, 64, 0.3)' }} />
          <div className="absolute inset-3 border border-[var(--weave-400)] rotate-45 opacity-60" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-2xl text-[var(--alert-coral)]">!</span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold tracking-wider text-[var(--chrome-100)] mb-3">
          NODE NOT FOUND
        </h2>

        {/* Description */}
        <p className="text-[var(--chrome-400)] mb-8 max-w-sm mx-auto">
          The requested data node does not exist in this sector of the Ideaverse. 
          It may have been moved or decommissioned.
        </p>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-8">
          <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent via-[var(--glass-border)] to-transparent" />
          <div className="w-1.5 h-1.5 bg-[var(--alert-coral)] rotate-45" />
          <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent via-[var(--glass-border)] to-transparent" />
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            to="/"
            className="btn-primary px-6 py-3 inline-flex items-center gap-2 no-underline"
          >
            <span>←</span>
            <span>Return to Ideaverse</span>
          </Link>
        </div>

        {/* Error Code */}
        <div className="mt-8 pt-6 border-t border-[var(--glass-border)]">
          <p className="text-xs text-[var(--chrome-500)] font-mono tracking-wider">
            ERROR_CODE: ENOENT • SECTOR: UNKNOWN • TIMESTAMP: {new Date().toISOString()}
          </p>
        </div>
      </div>
    </div>
  )
}

export default NotFound
